/* Announcement bar slider — vanilla JS, sin deps. */
(function () {
  'use strict';

  function initAnnouncement(root) {
    var slides = root.querySelectorAll('[data-announcement-slide]');
    if (slides.length < 2) return;

    var prev = root.querySelector('[data-announcement-prev]');
    var next = root.querySelector('[data-announcement-next]');
    var index = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 5000;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === index);
      });
    }

    function start() {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(function () { show(index + 1); }, interval);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    start();
  }

  function init() {
    document.querySelectorAll('[data-announcement]').forEach(initAnnouncement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init en theme editor cuando se reescribe la sección.
  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target.querySelector('[data-announcement]');
    if (node) initAnnouncement(node);
  });
})();
